import { useQuery } from "@tanstack/vue-query";

import { ConsumptionQueryKeys } from "@/data/api/kili/consumption/consumption-query-keys";
import KiliApi from "@/data/api/kili/kili-api";

export function useGetUserOrganizationPerimeterQuery() {
  return useQuery({
    queryKey: ConsumptionQueryKeys.sitesPerimeter(),
    queryFn: async () => KiliApi.getUserOrganizationPerimeter(),
  });
}
